// import React, { Component } from 'react';
// import { confirmAlert } from 'react-confirm-alert';
// import Tooltip from '../../shared/UI/Tooltip/Tooltip';
// import { Button } from 'primereact/button';

// import * as actions from '../../store/actions/index';
// import { connect } from 'react-redux';

// class POSTopbar extends Component {

//     constructor(props) {
//         super(props);
//         this.state = {
//             outletMenuOpen: false
//         };
//         this.outletRef = React.createRef();
//         this.handleClickOutside = this.handleClickOutside.bind(this);
//     }

//     logout = () => {

//         confirmAlert({
//             title: 'Do you want to quit?',
//             message: 'Are you sure.',
//             buttons: [
//                 {
//                     label: 'Yes',
//                     onClick: () => this.props.history.push('/log-out')
//                 },
//                 {
//                     label: 'No',
//                     //   onClick: () => alert('Click No')
//                 }
//             ]
//         });
//     };

//     componentDidMount() {
//         document.addEventListener('mousedown', this.handleClickOutside);
//         this.props.getMasterKeywordList('Branch');
//     }

//     componentWillUnmount() {
//         document.removeEventListener('mousedown', this.handleClickOutside);
//     }

//     handleClickOutside(event) {
//         if (this.outletRef.current && !this.outletRef.current.contains(event.target)) {
//             this.setState({ outletMenuOpen: false });
//         }
//     }

//     toggleOutletMenu = () => {
//         this.setState({ outletMenuOpen: !this.state.outletMenuOpen });
//     };

//     handleOutletSelect = (outlet) => {

//     this.setState({
//         outletMenuOpen: false
//     });

//     this.props.setSelectedBranch(outlet);
// };

//     render() {

//         const { onToggleMenu, userDetail, Branch = [], selectedOutlet, onLogout } = this.props;
//         const { outletMenuOpen } = this.state;

//         console.log('selectedOutlet', selectedOutlet);


//         return (
//             <div className="pos-topbar">

//                 <div className="pos-topbar-left">
//                     <button className="pos-menu-toggle" onClick={onToggleMenu}>
//                         ☰
//                     </button>
//                     <h2>Chenthoor POS</h2>
//                 </div>

//                 <div className="pos-topbar-right">

//                     <span className="pos-user-name">
//                         {userDetail && userDetail.userid1 ? userDetail.userid1 : 'Cashier'}
//                     </span>

//                     <div className="pos-outlet-dropdown" ref={this.outletRef}>
//                         <button
//                             className="pos-outlet-btn"
//                             onClick={this.toggleOutletMenu}
//                         >
//                             {selectedOutlet ? selectedOutlet.label : 'Select branch'} <span className="pos-outlet-caret">▾</span>
//                         </button>

//                         {outletMenuOpen && (
//                             <div className="pos-outlet-menu">
//                                 {Branch.length > 0 ? (
//                                     Branch.map((outlet) => (
//                                         <div
//                                             key={outlet.value}
//                                             className="pos-outlet-item"
//                                             onClick={() => this.handleOutletSelect(outlet)}
//                                         >
//                                             {outlet.label}
//                                         </div>
//                                     ))
//                                 ) : (
//                                     <div className="pos-outlet-item pos-outlet-empty">No branches found</div>
//                                 )}
//                             </div>
//                         )}
//                     </div>

//                     <Button classname="pos-logout-btn" icon="pi pi-power-off" rounded text severity="danger" onClick={this.logout} tooltip="Logout" tooltipOptions={{ position: 'bottom' }} />

//                 </div>
//             </div>
//         );
//     }
// }const mapstateToProps = (state) => {
//     return {
//       Branch: state.keyword.Branch,
//       loggedUserDetail: state.auth.loggedUserDetail,
//       userDetail: state.auth.userDetail,
//       selectedOutlet: state.master.selectedBranch
//     };
// }

// const mapdispatchToProps = (dispatch) => {
//     return {
//         // onLogout: () => dispatch({ type: 'LOGOUT' })
//         getMasterKeywordList: (keyword) => dispatch(actions.getMasterKeywordList(keyword)),
//         setSelectedBranch: (branch) => dispatch(actions.setSelectedBranch(branch))
//     };
// }

// export default connect(mapstateToProps, mapdispatchToProps)(POSTopbar);


import React, { Component } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import Tooltip from '../../shared/UI/Tooltip/Tooltip';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { Redirect } from 'react-router-dom';

import * as actions from '../../store/actions/index';
import { LOGIN_PATH } from '../../shared/utility';
import { connect } from 'react-redux';

class POSTopbar extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    }

    logout = () => {
        confirmAlert({
            title: 'Do you want to quit?',
            message: 'Are you sure.',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => {
                        this.props.onLogout();
                        setTimeout(()=>{
            window.location.reload(false);
        },1000)
        // Inert — returning JSX from a click handler renders nothing; the reload
        // above is what navigates, and POSApp then sends a signed-out staff
        // session to LOGIN_PATH. Kept only so this doesn't read as pointing at
        // "/", which is the customer home page now.
        return <Redirect to={LOGIN_PATH}/>;
                    }
                },
                {
                    label: 'No',
                }
            ]
        });
    };

   componentDidMount() {
    this.props.getMasterKeywordList('Branch');
    this.trySetDefaultBranch();
}

componentDidUpdate(prevProps) {
    const { Branch, userDetail } = this.props;
    const branchChanged = prevProps.Branch !== Branch;
    const userChanged = prevProps.userDetail !== userDetail;

    if (branchChanged || userChanged) {
        this.trySetDefaultBranch();
    }
}

trySetDefaultBranch = () => {
    const { Branch, userDetail, selectedOutlet, setSelectedBranch } = this.props;

    if (selectedOutlet) return; // already selected, don't override
    if (!Branch || Branch.length === 0) return;
    if (!userDetail || !userDetail.defaultbranch) return;

    const defaultOutlet = Branch.find(
        (outlet) => String(outlet.value) === String(userDetail.defaultbranch)
    );

    if (defaultOutlet) {
        setSelectedBranch(defaultOutlet.value);
    }
};

    handleOutletSelect = (e) => {
        // e.value is the full outlet object since options are the Branch array itself
        this.props.setSelectedBranch(e.value);
    };

    render() {

        const { onToggleMenu, userDetail, Branch = [], selectedOutlet } = this.props;

        console.log(this.props);
 

        return (
            <div className="pos-topbar">

                <div className="pos-topbar-left">
                    <button className="pos-menu-toggle" onClick={onToggleMenu}>
                        ☰
                    </button>
                    <h2>Chenthoor POS</h2>
                </div>

                <div className="pos-topbar-right">

                    <span className="pos-user-name">
                        {userDetail && userDetail.userid1 ? userDetail.userid1 : 'Cashier'}
                    </span>

                    <Dropdown
                        className="pos-outlet-dropdown"
                        value={selectedOutlet}
                        options={Branch}
                        optionLabel="label"
                        dataKey='value'
                        placeholder="Select branch"
                        onChange={this.handleOutletSelect}
                        emptyMessage="No branches found"
                        style={{ height: '30px' }}
                    />

                    <Button
                        className="pos-logout-btn"
                        icon="pi pi-power-off"
                        rounded
                        text
                        severity="danger"
                        onClick={this.logout}
                        tooltip="Logout"
                        tooltipOptions={{ position: 'bottom' }}
                    />

                </div>
            </div>
        );
    }
}

const mapstateToProps = (state) => {
    return {
        Branch: state.keyword.Branch,
        // loggedUserDetail: state.auth.userobject,
        userDetail: state.auth.userDetail,
        selectedOutlet: state.master.selectedBranch
    };
}

const mapdispatchToProps = (dispatch) => {
    return {
        getMasterKeywordList: (keyword) => dispatch(actions.getMasterKeywordList(keyword)),
        setSelectedBranch: (branch) => dispatch(actions.setSelectedBranch(branch)),
        onLogout: () => dispatch(actions.logout())
    };
}

export default connect(mapstateToProps, mapdispatchToProps)(POSTopbar);